import { useEffect, useRef } from "react";
import { PostHogCustomEvent, PostHogCustomProperties } from "./usePostHog";
import { useWidgetTrack } from "widgets/shared/WidgetTrackingContext";

export const useTrackImpression = (properties: PostHogCustomProperties) => {
  const track = useWidgetTrack();
  const elementRef = useRef<HTMLDivElement>(null);
  const hasBeenViewed = useRef(false);

  useEffect(() => {
    const currentElement = elementRef.current;

    if (!currentElement || hasBeenViewed.current) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasBeenViewed.current) {
            track(PostHogCustomEvent.EntityImpression, properties);
            hasBeenViewed.current = true;
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(currentElement);

    return () => {
      observer.disconnect();
    };
  }, [properties, track]);

  return elementRef;
};
